<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">ANÁLISIS DE LABORATORIOS EXTERNOS</v-card-title>
                    </v-col>
                    <v-col cols="1"  @click="abrirAyudas" >
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
            </v-card-text>
        
            <v-tabs
                fixed-tabs
                background-color="cyan darken-3"
                dark
                v-model="tabs"
            >
            <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab key="informes_muestreos">
                    <v-card-title>
                        Informes Muestreos
                    </v-card-title>
                </v-tab>
                <v-tab key="importar_pdf">
                    <v-card-title>
                        Importar desde PDF
                    </v-card-title>
                </v-tab>
                <v-tab key="importar_excel">
                    <v-card-title>
                        Importar desde Excel
                    </v-card-title>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
                <v-tab-item key="informes_muestreos">
                    <tab-informes-muestreos></tab-informes-muestreos>
                </v-tab-item>
                <v-tab-item key="importar_pdf">
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-file-input
                                    id="input_archivo"
                                    @change="cambioArchivo('pdf')"
                                    v-model="archivos.pdf" 
                                    label="Agregue PDF" 
                                    accept=".pdf"
                                    outlined 
                                    dense>
                                </v-file-input>
                            </v-col>
                            <v-col>
                                <v-select
                                    :items="laboratorios"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="laboratorio"
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-btn color="green darken-1"  :dark="!desactivar_importar" :disabled="desactivar_importar" @click="subirArchivo('pdf')"><v-icon>publish</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-text v-if="parametros_no_existentes.length > 0">
                        <v-row>
                            <v-col class="d-flex justify-center">
                                <v-btn color="blue darken-1" @click="importarParametros" dark>Importar parámetros</v-btn>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="d-flex justify-space-around py-4 w-full">
                                <h4> Los siguientes parámetros no existen en la Base de Datos, por favor seleccione los que quiera importar y pulse en importar u omita esta tabla</h4>
                            </v-col>
                        </v-row>

                        <v-data-table
                            :headers="cabeceras_parametros"
                            :items="parametros_no_existentes"
                            class="elevation-1"
                        >
                            <template v-slot:item.selected="{ item }">
                                <div class="d-flex justify-center">
                                    <v-checkbox
                                        v-model="item.seleccionado"
                                    ></v-checkbox>
                                </div>
                            </template>

                            <template v-slot:item.tipo="{ item }">
                                <v-select
                                    :items="[{text: 'Texto', value: 'select'}, {text: 'Número', value: 'numero'}]"
                                    v-model="item.tipo"
                                    item-text="text"
                                    item-value="value"
                                ></v-select>
                            </template>

                            <template v-slot:item.extra="{ item }">
                                <v-combobox
                                    v-if="item.tipo === 'select'"
                                    v-model="item.opciones"
                                    :items="item.opciones"
                                    label="Opciones"
                                    multiple
                                    chips
                                ></v-combobox>
                            </template>

                        </v-data-table>
                    </v-card-text>

                    <v-card-text>
                        <v-row>
                            <v-col class="d-flex justify-center" v-if="datos.length > 0">
                                <v-btn color="green darken-1" @click="importarDatos()" dark>Importar datos <v-icon>save</v-icon></v-btn>
                            </v-col>
                        </v-row>

                        <v-row v-if="titulo && laboratorio_seleccionado">
                            <v-col class="d-flex justify-space-around text-h5 py-4 w-full">
                                <h4> Título: {{ titulo }}</h4>
                                <h4> Laboratorio: {{ laboratorio_seleccionado.nombre }}</h4>
                            </v-col>
                        </v-row>

                        <v-alert
                            v-if="success"
                            type="success"
                            dismissible
                        >
                            ¡Informes con el título {{ titulo }} ingresados correctamente!
                        </v-alert>

                        <v-data-table
                            :headers="cabeceras"
                            :items="datos"
                            class="elevation-1"
                        >
                            <template v-slot:item="{ item }">
                                <tr class="text-right">
                                    <template v-for="cabecera in cabeceras">
                                        <td v-if="cabecera.value === 'actions'">
                                            <div class="d-flex justify-center">
                                                <v-icon @click="habilitarInputs(item)" color="blue" title="Habilitar/deshabilitar edición">edit</v-icon>
                                            </div>
                                        </td>

                                        <td v-else-if="item.input && !cabecera.inmutable && cabecera.exist" class="text-center">
                                            <div class="d-flex" :style="{ gap: '3px' }">
                                                <template v-if="item[`simbolo_${cabecera.value}`]">
                                                    <v-select
                                                        :items="simbolos"
                                                        v-model="item[`simbolo_${cabecera.value}`]"
                                                        title=""
                                                        :style="{ width: 'min-content' }"
                                                    >
                                                    </v-select>
                                                </template>

                                                <v-text-field
                                                    v-if="cabecera.type === 'number'"
                                                    :type="cabecera.type"
                                                    step=".01"
                                                    :rules="[rules.number]"
                                                    v-model="item[cabecera.value]"
                                                ></v-text-field>
                                                <v-select
                                                    v-else-if="cabecera.type === 'select'"
                                                    :items="cabecera.options"
                                                    v-model="item[cabecera.value].id"
                                                    @change="() => item[cabecera.value].text = cabecera.options.find(option => option.id === item[cabecera.value].id).text"
                                                    item-text="text"
                                                    item-value="id"
                                                ></v-select>
                                                <v-text-field
                                                    v-else
                                                    type="text"
                                                    v-model="item[cabecera.value]"
                                                ></v-text-field>
                                            </div>
                                            
                                        </td>
                                        <td v-else class="text-center">
                                            <template v-if="item[`simbolo_${cabecera.value}`]">{{ item[`simbolo_${cabecera.value}`] }}</template>
                                            <template v-if="cabecera.type === 'select'">
                                                {{ item[cabecera.value].text }}
                                            </template>
                                            <template v-else>
                                                {{ item[cabecera.value] }}
                                            </template>
                                            <template v-if="item.id && cabecera.value === 'lote'">
                                                <v-icon title="Lote previamente ingresado, se modificará información existente del lote" color="blue">info</v-icon>
                                            </template>
                                            <template v-if="!item.exists_db && cabecera.value === 'lote'">
                                                <v-icon title="Lote no existe en base de datos, no se ingresará" color="red">info</v-icon>
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-tab-item>
                <v-tab-item key="importar_excel">
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-file-input
                                    id="input_archivo"
                                    @change="cambioArchivo('excel')"
                                    v-model="archivos.excel" 
                                    label="Agregue Excel" 
                                    accept=".xlsx, .xls"
                                    outlined
                                    hide-details
                                    dense>
                                </v-file-input>
                            </v-col>
                            <v-col>
                                <v-select
                                    label="Laboratorio"
                                    :items="laboratorios"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="laboratorio"
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-btn color="green darken-1"  :dark="!desactivar_importar_excel" :disabled="desactivar_importar_excel" @click="subirArchivo('excel')"><v-icon>publish</v-icon></v-btn>
                            </v-col>
                            <v-col>
                                <v-dialog
                                    v-model="parametros_dialog"
                                    width="500"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                                            Ver parámetros
                                        </v-btn>
                                    </template>

                                    <v-card>
                                        <v-card-title class="text-h5 grey lighten-2">
                                            Parámetros
                                        </v-card-title>

                                        <v-card-text>
                                            <v-data-table
                                                :headers="[{text: 'Nombre', value: 'nombre_parametro'}, {text: 'Nombre alternativo', value: 'nombre_pdf_cesmec'}]"
                                                :items="parametros_filtrados"
                                                :items-per-page="10"
                                            >
                                            </v-data-table>
                                        </v-card-text>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="primary"
                                                text
                                                @click="parametros_dialog = false"
                                            >
                                                Cerrar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                            <v-col>
                                <v-btn color="green" dark title="Descargar formato excel (modificar cabeceras y valores de campos con cabeceras resaltadas en amarillo)" @click="descargarFormato()">
                                    Exportar Formato Excel
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text>
                        <v-row>
                            <v-col class="d-flex justify-center" v-if="datos_excel.length > 0">
                                <v-btn color="green darken-1" @click="importarDatos('excel')" dark>Importar datos <v-icon>save</v-icon></v-btn>
                            </v-col>
                        </v-row>

                        <v-row v-if="laboratorio_seleccionado_excel.nombre">
                            <v-col class="d-flex justify-space-around text-h5 py-4 w-full">
                                <h4> Laboratorio: {{ laboratorio_seleccionado_excel.nombre }}</h4>
                            </v-col>
                        </v-row>

                        <v-alert
                            v-if="success_excel"
                            type="success"
                            dismissible
                        >
                            ¡Muestreos desde excel ingresados correctamente!
                        </v-alert>

                        <v-data-table
                            :headers="cabeceras_excel"
                            :items="datos_excel"
                            class="elevation-1"
                        >
                            <template v-slot:item="{ item }">
                                <tr class="text-right">
                                    <template v-for="cabecera in cabeceras_excel">
                                        <td v-if="cabecera.value === 'actions'">
                                            <div class="d-flex justify-center">
                                                <v-icon @click="habilitarInputs(item)" color="blue" title="Habilitar/deshabilitar edición">edit</v-icon>
                                            </div>
                                        </td>

                                        <td v-else-if="cabecera.value === 'informes'" class="text-center">
                                            {{ item.informes ? item.informes.join(' - ') : '' }}
                                        </td>

                                        <td v-else-if="item.input && !cabecera.inmutable && cabecera.exist" class="text-center">
                                            <div class="d-flex" :style="{ gap: '3px' }">
                                                <template v-if="item[`simbolo_${cabecera.value}`]">
                                                    <v-select
                                                        :items="simbolos"
                                                        v-model="item[`simbolo_${cabecera.value}`]"
                                                        title=""
                                                        :style="{ width: 'min-content' }"
                                                    >
                                                    </v-select>
                                                </template>

                                                <v-text-field
                                                    v-if="cabecera.type === 'number'"
                                                    :type="cabecera.type"
                                                    step=".01"
                                                    :rules="[rules.number]"
                                                    v-model="item[cabecera.value]"
                                                ></v-text-field>
                                                <v-select
                                                    v-else-if="cabecera.type === 'select'"
                                                    :items="cabecera.options"
                                                    v-model="item[cabecera.value].id"
                                                    @change="() => item[cabecera.value].text = cabecera.options.find(option => option.id === item[cabecera.value].id).text"
                                                    item-text="text"
                                                    item-value="id"
                                                ></v-select>
                                                <v-text-field
                                                    v-else
                                                    type="text"
                                                    v-model="item[cabecera.value]"
                                                ></v-text-field>
                                            </div>
                                            
                                        </td>
                                        <td v-else class="text-center">
                                            <template v-if="item[`simbolo_${cabecera.value}`]">{{ item[`simbolo_${cabecera.value}`] }}</template>
                                            <template v-if="cabecera.type === 'select'">
                                                {{ item[cabecera.value].text }}
                                            </template>
                                            <template v-else>
                                                {{ item[cabecera.value] }}
                                            </template>
                                            <template v-if="item.id && cabecera.value === 'lote'">
                                                <v-icon title="Lote previamente ingresado, se modificará información existente del lote" color="blue">info</v-icon>
                                            </template>
                                            <template v-if="!item.exists_db && cabecera.value === 'lote'">
                                                <v-icon title="Lote no existe en base de datos, no se ingresará" color="red">info</v-icon>
                                            </template>
                                        </td>
                                    </template>
                                </tr>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import TabMuestreos from './TabMuestreos.vue'

export default {
    data() {
        return {
            tabs: null,
            laboratorios: [],
            laboratorio: null,
            laboratorio_seleccionado: {},
            laboratorio_seleccionado_excel: {},
            archivos: {
                pdf: null,
                excel: null,
            },
            datos: [],
            cabeceras: [],
            simbolos: ['>', '<', '='],
            titulo: '',
            url_archivo: null,
            url_archivo_excel: null,
            rules: {
                number: value => {
                    const regex = /^-?\d+(\.\d{1,2})?$/;
                    return regex.test(value) || 'Valor debe ser numérico con máximo dos decimales'
                }
            },
            success: false,
            success_excel: false,
            parametros: [],
            parametros_no_existentes: [],
            cabeceras_parametros: [
                { text: 'Seleccionado', value: 'selected', class: 'cabecera', sortable: true, align: 'center'},
                { text: 'Parámetro', value: 'parametro', class: 'cabecera', sortable: true, align: 'center'},
                { text: 'Tipo', value: 'tipo', class: 'cabecera', sortable: true, align: 'center'},
                { text: 'Extra', value: 'extra', class: 'cabecera', sortable: true, align: 'center'},
            ],
            parametros_dialog: false,
            datos_excel: [],
            cabeceras_excel: [],
            parametros_no_existentes_excel: [],
            formatos_aceptados: {
                pdf: ['application/pdf'],
                excel: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/wps-office.xlsx'],
            },
        }
    },

    mounted() {
        this.cargarLaboratorios();
        this.cargarParametros();
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Importación de Análisis de Laboratorios Externos`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se realiza la importación de los informes de análisis de laboratorios externos en formato PDF e indicando el laboratorio correspondiente. `},
                        {   tipo:`label`,   texto:`- Primero se sube el archivo PDF del informe en el selector de archivos correspondiente, se selecciona el laboratorio y se sube con el botón verde.`},
                        {   tipo:`label`,   texto:`- Luego este informe se subirá y se procesará.`},
                        {   tipo:`label`,   texto:`- Una vez se haya procesado el informe, se mostrará una tabla con el número del lote (e información extra con el símbolo de una i a un lado, en caso de que corresponda) y cada una de las muestras leídas de ese lote con sus respectivos valores.`},
                        {   tipo:`label`,   texto:`- En la columna "Acciones", se muestra el icono de un lápiz en azul, el cual, al pulsarlo, habilitará la edición de cada muestreo de ese lote. Si se habilita, se podrá modificar cada valor mediante un campo de texto/selector en la celda correspondiente. Si se pulsa nuevamente el icono del lapiz, se deshabilitará la edición y se conservarán los cambios realizados. En caso de que el parámetro no exista, la cabecera de la columna estará marcada de un color amarillo/naranjo y no se podrá modificar, por lo que tampoco se importará esa información.`},
                        {   tipo:`label`,   texto:`- Finalmente con el botón "Importar Datos" se importarán todos los datos del los muestreos del informe`},
                        {   tipo:`label`,   texto:`- Adicionalmente, si al leer la información se detectan parámetros que no existan, se mostrará una tabla opcional que servirá para poder ingresar a la base de datos esos parámetros e indicar, mediante un selector en su columna "Tipo", si es un Número o Texto. En caso de ser Texto, se habilitará en la columna "Extra", la posibilidad de agregar opciones digitándolas con el teclado y pulsando enter para agregarlas.`},
                        {   tipo:`label`,   texto:`- Para importar estos parámetros se debe pulsar el botón "Importar párametros" mostrado en color azul.  Nota: solo se importarán los parámetros que estén marcados en la primera columna de "Seleccionado"`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        cargarLaboratorios() {
            this.mostrarLoading({ titulo: 'Obteniendo datos de laboratorios...', color: 'green' });
            const url = `${this.base_url}laboratorios`;
            this.axios.get(url, this.headers).then(res => {
                console.log(res);
                this.laboratorios = res.data.data;
                if(this.laboratorios.length > 0)
                    this.laboratorio = this.laboratorios[0].id;
                
                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al obtener datos");
            });
        },

        cargarParametros() {
            this.mostrarLoading({titulo: 'Cargando listado de parámetros...', color: 'green'})

            const url = `${this.base_url}parametros`;
            this.axios.get(url, this.headers).then(res => {
                this.parametros = res.data.data
                console.log({parametros: this.parametros});
                this.ocultarLoading();
            }).catch(error => {
                console.log('error', error);
                this.errorMessage(error, "Error")
            });
        },

        cambioArchivo(tipo = 'pdf') {
            console.log('archivo', this.archivos[tipo]);
            // Busca entre los formatos aceptados
            const aceptado = this.formatos_aceptados[tipo].find(formato => formato === this.archivos[tipo].type);
            this.archivos[tipo] = !aceptado ? {} : this.archivos[tipo];
            console.log('aceptado', aceptado);
        },

        subirArchivo(tipo = 'pdf') {
            this.mostrarLoading({ titulo: 'Subiendo archivo...', color: 'green' });
            const url = `${this.base_url}informe_muestreo/subir_archivo`;
            const body = new FormData();
            body.append('archivo', this.archivos[tipo]);

            const token = this.headers.headers['Authorization'];
            const headers = {
                headers:{
                    'Authorization':token,
                    'Content-Type':'multipart/form-data'
                }
            }
            this.axios.post(url, body, headers).then(res => {
                console.log(res);
                this.ocultarLoading();
                
                if(tipo === 'pdf') {
                    this.success = false;
                    this.url_archivo = res.data.nombre;
                    this.enviarNombreArchivo(this.url_archivo);
                }
                if(tipo === 'excel') {
                    this.success_excel = false;
                    this.url_archivo_excel = res.data.nombre;
                    this.enviarNombreArchivoExcel(this.url_archivo_excel);
                }

            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al subir archivo");
            });
        },

        enviarNombreArchivo(nombre_archivo) {
            this.mostrarLoading({ titulo: 'Procesando archivo...', color: 'green' });
            const url = `${this.base_url}informe_muestreo/obtener_muestreo`;
            const body = { nombre_archivo, laboratorio: this.laboratorio };

            this.axios.post(url, body, this.headers).then(res => {
                console.log(res);
                
                if(res.data.data === null) {
                    throw new Error('No se encontraron datos');
                }
                console.log(res.data.data);
                this.laboratorio_seleccionado = res.data.laboratorio;

                this.titulo = res.data.data.title;
                let datos = res.data.data.data;
                datos = this.estandarizarValores(datos);
                console.log({ datos: datos });

                // Se agregan las cabeceras provenientes del Script con el formato que necesita la tabla
                const { cabeceras, parametros_no_existentes } = this.obtenerCabeceras(res.data.data.headers);
                this.cabeceras = cabeceras;
                this.parametros_no_existentes = parametros_no_existentes;

                console.log(this.parametros_no_existentes);

                // Se verifica si ya existen los informes en la BD
                this.datos = this.verificarMuestreosDB(datos, res.data.data.informes_muestreos);

                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al obtener datos");
            });
        },

        enviarNombreArchivoExcel(nombre_archivo) {
            this.mostrarLoading({ titulo: 'Procesando archivo...', color: 'green' });
            const url = `${this.base_url}informe_muestreo/obtener_muestreo_excel`;
            const body = { nombre_archivo, laboratorio: this.laboratorio };

            this.axios.post(url, body, this.headers).then(res => {
                console.log(res);
                
                if(res.data.data === null) {
                    throw new Error('No se encontraron datos');
                }

                let datos = this.estandarizarValores(res.data.data);

                let { cabeceras, parametros_no_existentes } = this.obtenerCabeceras(res.data.headers);
                cabeceras.splice(1, 0, {
                    align: 'center',
                    sortable: true,
                    class: 'cabecera',
                    exist: true,
                    text: 'Informes',
                    value: 'informes',
                    type: 'text',
                    inmutable: true,
                });
                this.cabeceras_excel = cabeceras;
                this.parametros_no_existentes_excel = parametros_no_existentes;
                this.laboratorio_seleccionado_excel = res.data.laboratorio;
                this.datos_excel = this.verificarMuestreosDB(datos);
                console.log(this.datos_excel);

                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al obtener datos");
            });
        },

        importarDatos(tipo = 'pdf') {
            this.mostrarLoading({ titulo: 'Importando datos...', color: 'green' });
            const url = `${this.base_url}informe_muestreo/importar_datos`;
            const body = {
                data: tipo === 'pdf' ? this.datos : this.datos_excel,
                nombre_informe: tipo === 'pdf' ? this.titulo : undefined,
                laboratorio: tipo === 'pdf' ? this.laboratorio_seleccionado.id : this.laboratorio_seleccionado_excel.id,
                url_archivo: this.url_archivo,
            };
            console.log(body, this.laboratorio_seleccionado)
            if(tipo === 'excel')
                body.excel = true; 

            this.axios.post(url, body, this.headers).then(res => {
                console.log(res);
                if(tipo === 'pdf') {
                    this.datos = [];
                    this.cabeceras = [];
                    this.parametros_no_existentes = [];
                    this.success = true;
                }
                if(tipo === 'excel') {
                    this.datos_excel = [];
                    this.cabeceras_excel = [];
                    this.parametros_no_existentes_excel = [];
                    this.success_excel = true;
                }
                this.cargarParametros();
                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al importar datos");
            });
        },

        importarDatosExcel() {
            this.mostrarLoading({ titulo: 'Importando datos...', color: 'green' });
            const url = `${this.base_url}informe_muestreo/importar_datos_excel`;
            const body = {
                data: this.datos,
                laboratorio: this.laboratorio_seleccionado.id,
                url_archivo: this.url_archivo_excel,
            };

            this.axios.post(url, body, this.headers).then(res => {
                console.log(res);
                this.datos = [];
                this.success = true;
                this.cargarParametros();
                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al importar datos");
            });
        },

        importarParametros() {
            this.mostrarLoading({ titulo: 'Importando parámetros...', color: 'green' });
            const url = `${this.base_url}parametro/save_parametros`;
            const body = this.parametros_no_existentes.filter(parametro => parametro.seleccionado).map(parametro =>({nombre_parametro: parametro.parametro, nombre_pdf_cesmec: parametro.parametro, ...parametro}));

            console.log(body);

            this.axios.post(url, body, this.headers).then(res => {
                console.log(res);
                const parametros_ingresados = res.data.data;

                this.parametros_no_existentes = this.parametros_no_existentes.filter(param => !param.seleccionado);
                this.cabeceras = this.cabeceras.map(cabecera => {
                    const parametro_ingresado = parametros_ingresados.find(param => param.nombre_parametro === cabecera.value);
                    if(parametro_ingresado) {
                        cabecera.exist = true;
                        cabecera.class = 'cabecera';

                        if(parametro_ingresado.tipo === 'select') {
                            cabecera.type = 'select';
                            cabecera.options = parametro_ingresado.opciones.map(opcion => ({text: opcion.opcion, id: opcion.id}));
                        }
                    }
                    
                    return cabecera;
                });

                this.datos = this.datos.map(dato => {
                    Object.keys(dato).forEach(key => {
                        const parametro_ingresado = parametros_ingresados.find(param => param.nombre_parametro === key);
                        if(parametro_ingresado && parametro_ingresado.tipo === 'select') {
                            const text = dato[key];
                            const value = parametro_ingresado.opciones.find(opcion => opcion.opcion === text);
                            dato[key] = {
                                text,
                                id: value.id || null,
                            };
                        }
                    });

                    return dato;
                });
                this.ocultarLoading();
            }).catch(error => {
                this.errorMessage(error);
                console.error(error, "Error al importar datos");
            });
        },
        
        // Se usa para obtener arreglo de objetos con los valores separados por . (los que son números), agregando símbolos a los valores correspondientes
        estandarizarValores(datos) {
            console.log(datos);
            const skip_keys = ['exists_db'];
            const agregar_simbolos = [];
            let nuevosDatos = Object.entries(datos).map(([lote, parametros]) => {
                const registro = {};
                registro.lote = lote;
                Object.entries(parametros).forEach(([parametro, value]) => {
                    if(typeof value === 'object' || skip_keys.includes(parametro)) {
                        registro[parametro] = value;
                        return;
                    }
                    value = value.replace(',', '.');
                    const simbolo = value.split('').find(char => this.simbolos.includes(char));
                    if(simbolo) {
                        agregar_simbolos.push(parametro);
                        const values = value.split(simbolo);
                        registro[`simbolo_${parametro}`] = simbolo;
                        value = values[1];
                    }

                    const value_float = parseFloat(value);

                    if(isNaN(value_float)) {
                        registro[parametro] = value;
                    } else {
                        registro[parametro] = value_float;
                    }
                });
                registro.input = false;
                return registro;
            });
            nuevosDatos = nuevosDatos.map(dato => {
                agregar_simbolos.forEach(parametro => {
                    if(!dato[`simbolo_${parametro}`])
                        dato[`simbolo_${parametro}`] = '=';
                });
                return dato;
            });
            return nuevosDatos;
        },

        // Se usa para obtener cabeceras de forma dinámica según información de cabeceras de PDF / Excel
        obtenerCabeceras(cabeceras_archivo) {
            const headers = cabeceras_archivo;

            const non_variables = {
                align: 'center',
                sortable: true,
                class: 'cabecera',
                type: 'number',
                exist: true,
            } 

            let cabeceras = [{
                text: 'Lote',
                value: 'lote',
                type: 'text',
                inmutable: true,
                ...non_variables,
            }];

            let parametros_no_existentes = [];

            cabeceras = [...cabeceras, ...headers.map(header => {
                const cabecera = {...non_variables};
                const parametro_encontrado = this.parametros_filtrados.find(parametro => header === parametro.nombre_pdf_cesmec || header === parametro.nombre_parametro);
                cabecera.text = header;
                cabecera.value = header;
                if(parametro_encontrado) {
                    cabecera.type = parametro_encontrado.tipo === 'numero' ? 'number' : parametro_encontrado.tipo;
                    if(parametro_encontrado.tipo === 'select') {
                        cabecera.options = parametro_encontrado.opciones.map(opcion => ({id: opcion.id, text: opcion.opcion}));
                    }
                } else {
                    cabecera.exist = false;
                    cabecera.class = 'cabecera-warning'
                    parametros_no_existentes.push(header);
                }
                return cabecera;
            })];

            cabeceras.push({
                text: 'Acciones',
                value: 'actions',
                ...non_variables,
            })

            parametros_no_existentes = parametros_no_existentes.map(param => {
                const obj = {
                    parametro: param,
                    seleccionado: false,
                    tipo: 'numero',
                    opciones: null,
                }
                return obj;
            });

            return {
                cabeceras,
                parametros_no_existentes
            }
        },

        // Se verifica si ya existen los informes en la BD
        verificarMuestreosDB(datos, informes_muestreos) {
            if(informes_muestreos) {
                const lotes_muestreos = {};
                informes_muestreos.forEach(muestreo => {
                    lotes_muestreos[muestreo.nombre_lote] = muestreo.id;
                });
                return datos.map(dato => {
                    if(lotes_muestreos[`${dato.lote}`]) {
                        dato.id = lotes_muestreos[`${dato.lote}`];   
                    }
                    return dato;
                });
            } else {
                return datos.map(dato => {
                    if(dato.informes_muestreos) {
                        dato.id = dato.informes_muestreos.id
                    }
                    return dato;
                });
            }
        },

        descargarFormato() {
            const url = `${this.base_url}informe_muestreo/formato_excel?laboratorio=${this.laboratorio}`;
            this.axios.get(url,this.headers).then(res => {
                window.location.href = res.data.data;
            }).catch(error => {
                console.log('error',error);
            });
        },

        habilitarInputs(item) {
            item.input = !item.input;
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },

    computed: {
        desactivar_importar(){
            if(this.archivos.pdf && this.archivos.pdf != {}) {
                const aceptado = this.formatos_aceptados.pdf.find(formato => formato === this.archivos.pdf.type);
                return !aceptado;
            }

            return true;
        },
        desactivar_importar_excel(){
            if(this.archivos.excel && this.archivos.excel != {}) {
                const aceptado = this.formatos_aceptados.excel.find(formato => formato === this.archivos.excel.type);
                return !aceptado;
            }

            return true;
        },
        parametros_filtrados() {
            return this.parametros.filter(parametro => parametro.nombre_pdf_cesmec);
        },
        ...mapState(['base_url', 'headers']),
    },

    components: {
        'modal-ayuda': ModalAyudas,
        'tab-informes-muestreos': TabMuestreos,
    }
}
</script>
<style>
.cabecera-warning {
    background-color: orange !important;
    color: #fff !important;
    text-align: center !important;
    font-size: 1em !important;
    padding: 0.5;
    margin: 0;
    border-right: 1px solid white !important;
}
</style>
